import {booleanCellRenderer, booleanComparator, booleanFilterCellRenderer} from "../helpers/boolean";

export let boolCol = {
	editable: true,
	cellRenderer: booleanCellRenderer,
	cellEditor: 'agRichSelectCellEditor',
	cellEditorParams: {
		values: [true, false],
		cellRenderer: booleanCellRenderer
	},
	cellStyle: function (params) {
		if (params.value == true) {
			return {
				textAlign: 'center',
				backgroundColor: '#cee9d4'
			};
		} else {
			return {
				textAlign: 'center',
				backgroundColor: '#e5cbcb',
			};
		}
	},
	filter: 'agSetColumnFilter',
	comparator: booleanComparator,
	resizable: true,
	filterParams: {
		cellRenderer: booleanFilterCellRenderer,
		selectAllOnMiniFilter: true,
		newRowsAction: 'keep',
		clearButton: true
	},
}